// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zoom-settings[data-v-2bca924e]{margin-bottom:1.25rem}@media(min-width:48rem){.zoom-settings[data-v-2bca924e]{margin-bottom:0}}", ""]);
// Exports
module.exports = exports;
